/* Energy Unleashed — homepage behaviour: intent tiles + bundle visualiser.
   Progressive: every panel is server-rendered; without JS the first panel shows
   and the visualiser shows its 5-tin default. Event delegation on document so
   it survives Section Rendering re-renders. */

(() => {
if (window.__euHome) return; window.__euHome = true;
const money = (n) => '$' + (Math.round(n * 100) / 100).toFixed(2);

// ---- intent tiles ------------------------------------------------------------
function selectIntent(root, key) {
  root.querySelectorAll('.euh-intent__tile').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.intent === key)));
  root.querySelectorAll('.euh-intent__panel').forEach((p) => { p.hidden = p.dataset.intent !== key; });
  root.querySelectorAll('.euh-intent__cta').forEach((c) => { c.hidden = c.dataset.intent !== key; });
}
document.addEventListener('click', (e) => {
  const tile = e.target instanceof Element ? e.target.closest('.euh-intent__tile') : null;
  if (!tile) return;
  const root = tile.closest('.euh-intent'); if (!root) return;
  selectIntent(root, tile.dataset.intent);
});
document.querySelectorAll('.euh-intent').forEach((root) => { const first = root.querySelector('.euh-intent__tile[aria-selected="true"]') || root.querySelector('.euh-intent__tile'); if (first) selectIntent(root, first.dataset.intent); });

// ---- bundle visualiser -----------------------------------------------------
function tierFor(viz, n) {
  const tiers = JSON.parse(viz.dataset.tiers); // [{tins, price, label}] ascending
  let t = tiers[0];
  for (const x of tiers) if (n >= x.tins) t = x;
  return { tiers, tier: t };
}
function updateViz(viz, n) {
  const pouches = +viz.dataset.pouches || 20;
  const { tiers, tier } = tierFor(viz, n);
  const onTier = tiers.some((t) => t.tins === n);
  const per = tier.price / (tier.tins * pouches);
  const total = onTier ? tier.price : n * pouches * per;
  const full = n * tiers[0].price;
  const q = (s) => viz.querySelector(s);
  q('[data-viz="tins"]').innerHTML = `${n}<small>Tin${n > 1 ? 's' : ''} · ${n * pouches} Pouches</small>`;
  q('[data-viz="pp"]').textContent = money(per) + ' / Pouch';
  q('[data-viz="tot"]').innerHTML = `${money(total)} Total${n > 1 && full > total + 0.005 ? ` <s>${money(full)}</s>` : ''}`;
  const bar = q('[data-viz="bar"]'); if (bar) bar.style.width = (n / tiers[tiers.length - 1].tins * 100) + '%';
  viz.querySelectorAll('.euh-viz__tin').forEach((t) => t.classList.toggle('is-on', +t.dataset.tin <= n));
  const rng = q('[data-viz="range"]'); if (rng) rng.value = String(n);
  viz.querySelectorAll('.euh-viz__tier').forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.tins === n)));
  const saveEl = q('[data-viz="save"]');
  if (saveEl) { const saved = full - total; if (saved > 0.005) { saveEl.textContent = 'Save ' + money(saved); saveEl.hidden = false; } else saveEl.hidden = true; }
  const note = q('[data-viz="note"]'); if (note) {
  if (n === 1) note.innerHTML = 'One tin at full price — <b>try a flavour first</b>.';
  else if (onTier) note.innerHTML = `Any <b>${n} Tins</b> · Mix Brands &amp; Flavours`;
  else note.innerHTML = `${n} tins price at the <b>${tier.tins}-tin rate</b>. Add ${tiers.find((t) => t.tins > n)?.tins - n} more for the next drop.`;
  }
  if (typeof bSetTier === 'function') bSetTier(viz, n, true);
}
document.addEventListener('input', (e) => {
  const r = e.target instanceof Element ? e.target.closest('[data-viz="range"]') : null;
  if (!r) return; updateViz(r.closest('.euh-viz'), +r.value);
});
document.addEventListener('click', (e) => {
  const b = e.target instanceof Element ? e.target.closest('.euh-viz__tier') : null;
  if (!b) return; updateViz(b.closest('.euh-viz'), +b.dataset.tins);
});
// ---- bundle builder ---------------------------------------------------------
// Local picks mirror the shared EUBundleDraft (eu-bundle-draft.js) both ways:
// an existing draft is adopted on load, and once the customer touches this
// builder every change is written through — so a build started here resumes on
// the collection pages and the PDP selector, and vice versa. Add = D.commit(),
// the same atomic /cart/add.js + _bundle_id path every other surface uses.
const builders = new WeakMap();
let writingDraft = false;
function bState(viz) { let st = builders.get(viz); if (!st) { st = { picks: [], tier: 5, touched: false }; builders.set(viz, st); } return st; }
function bRefs(viz) { const q = (k) => viz.querySelector(`[data-b="${k}"]`); return { root: viz.querySelector('[data-builder]'), toggle: q('toggle'), offtier: q('offtier'), slots: q('slots'), picker: q('picker'), count: q('count'), add: q('add'), msg: q('msg') }; }
function bMsg(viz, text, err) { const r = bRefs(viz); if (!r.msg) return; r.msg.textContent = text || ''; r.msg.classList.toggle('is-err', !!err); }
function bCatalogue(viz) { const map = {}; viz.querySelectorAll('[data-b="tin"]').forEach((t) => { const img = t.querySelector('img'); map[t.dataset.id] = { id: t.dataset.id, name: t.querySelector('span')?.textContent || 'Tin', img: img ? img.currentSrc || img.src : null }; }); return map; }
function bTierPrice(viz, n) { const tiers = JSON.parse(viz.dataset.tiers); let t = tiers[0]; for (const x of tiers) if (n >= x.tins) t = x; return tiers.some((x) => x.tins === n) ? t.price : null; }
function bWriteDraft(viz) {
  const st = bState(viz); const D = window.EUBundleDraft;
  if (!D || !st.touched || ![3, 5, 10].includes(st.tier)) return;
  writingDraft = true;
  try { D.start(st.tier); D.reset(); st.picks.forEach((p) => D.add(p.id)); } finally { setTimeout(() => { writingDraft = false; }, 0); }
}
function bAdopt(viz) {
  const D = window.EUBundleDraft; if (!D) return false;
  const d = D.read(); if (!d || ![3, 5, 10].includes(d.tier)) return false;
  const cat = bCatalogue(viz); const st = bState(viz);
  const picks = d.slots.filter((x) => x != null).map((id) => cat[String(id)] || { id: String(id), name: 'Picked tin', img: null });
  if (!picks.length) return false;
  st.tier = d.tier; st.picks = picks.slice(0, d.tier); st.touched = true;
  updateViz(viz, d.tier);
  return true;
}
function bRender(viz) {
  const st = bState(viz); const r = bRefs(viz); if (!r.root) return;
  const onTier = [1, 3, 5, 10].includes(st.tier);
  r.offtier.hidden = onTier; r.slots.hidden = !onTier;
  r.toggle.style.display = onTier ? '' : 'none';
  r.add.style.display = onTier ? '' : 'none';
  r.count.style.display = onTier ? '' : 'none';
  if (!onTier) { r.picker.hidden = true; r.toggle.setAttribute('aria-expanded', 'false'); return; }
  st.picks = st.picks.slice(0, st.tier);
  r.slots.innerHTML = '';
  for (let i = 0; i < st.tier; i++) {
    const pick = st.picks[i];
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'euh-build__slot' + (pick ? ' is-filled' : ''); b.dataset.slot = String(i);
    if (pick) { b.title = 'Remove ' + pick.name; b.setAttribute('aria-label', 'Remove ' + pick.name); if (pick.img) b.innerHTML = `<img src="${pick.img}" alt="">`; else b.textContent = '✓'; }
    else { b.textContent = '+'; b.title = 'Pick a flavour'; b.setAttribute('aria-label', 'Pick a flavour'); }
    r.slots.appendChild(b);
  }
  const n = st.picks.length;
  r.count.innerHTML = `<b>${n}</b> of ${st.tier} Picked`;
  const price = bTierPrice(viz, st.tier);
  r.add.textContent = `Add ${st.tier} Tin${st.tier > 1 ? 's' : ''}${price ? ' · ' + money(price) : ''}`;
  r.toggle.classList.toggle('is-primary', n < st.tier);
  r.toggle.textContent = n >= st.tier ? 'Swap a Flavour' : `Choose ${st.tier - n} ${n ? 'More ' : ''}Flavour${st.tier - n > 1 ? 's' : ''}`;
  r.add.disabled = n !== st.tier || !window.EUBundleDraft;
}
function bSetTier(viz, n, fromUser) {
  const st = bState(viz); st.tier = n;
  if (fromUser && st.picks.length) { st.touched = true; }
  bRender(viz);
  if (st.touched) bWriteDraft(viz);
}
document.addEventListener('click', (e) => {
  const el = e.target instanceof Element ? e.target : null; if (!el) return;
  const viz = el.closest('.euh-viz'); if (!viz) return;
  const r = bRefs(viz); const st = bState(viz);
  const toggle = el.closest('[data-b="toggle"]');
  if (toggle) { const open = r.picker.hidden; r.picker.hidden = !open; toggle.setAttribute('aria-expanded', String(open)); if (open) bMsg(viz, ''); return; }
  const tin = el.closest('[data-b="tin"]');
  if (tin) {
    if (st.picks.length >= st.tier) { bMsg(viz, `That's ${st.tier} — remove one to swap, or add the bundle.`); return; }
    const img = tin.querySelector('img');
    st.picks.push({ id: tin.dataset.id, name: tin.querySelector('span')?.textContent || '', img: img ? img.currentSrc || img.src : null });
    st.touched = true; bMsg(viz, ''); bRender(viz); bWriteDraft(viz);
    if (st.picks.length === st.tier) { r.picker.hidden = true; r.toggle.setAttribute('aria-expanded', 'false'); }
    return;
  }
  const slot = el.closest('.euh-build__slot');
  if (slot) {
    if (slot.classList.contains('is-filled')) { st.picks.splice(+slot.dataset.slot, 1); st.touched = true; bRender(viz); bWriteDraft(viz); }
    else { r.picker.hidden = false; r.toggle.setAttribute('aria-expanded', 'true'); bMsg(viz, ''); }
    return;
  }
  const add = el.closest('[data-b="add"]');
  if (add && !add.disabled) {
    const D = window.EUBundleDraft;
    if (!D) { bMsg(viz, 'Builder is still loading — try again in a second.', true); return; }
    add.disabled = true; bMsg(viz, 'Adding your bundle…');
    bWriteDraft(viz);
    D.commit().then(() => {
      D.clear(); st.picks = []; st.touched = false; bRender(viz);
      bMsg(viz, 'Bundle added — opening your cart.');
      if (window.EUCart && window.EUCart.refresh) window.EUCart.refresh().then(() => window.EUCart.open && window.EUCart.open());
      else window.location.href = '/cart';
    }).catch((err) => { add.disabled = false; bMsg(viz, (err && err.message) || 'Something went wrong — try again.', true); });
    return;
  }
});
// a draft changed elsewhere (another tab, the collection builder) — re-adopt
window.addEventListener('eu:bundle-draft', () => { if (writingDraft) return; document.querySelectorAll('.euh-viz').forEach((viz) => { const st = bState(viz); if (!st.touched) bAdopt(viz); }); });
// eu-bundle-draft.js is a deferred script from another section and may land
// after this module runs — paint the default immediately, then adopt/enable
// once the draft API shows up (short poll, then give up quietly).
document.querySelectorAll('.euh-viz').forEach((viz) => updateViz(viz, +viz.dataset.start || 5));
(function waitDraft(tries) {
  if (window.EUBundleDraft) {
    document.querySelectorAll('.euh-viz').forEach((viz) => { const st = bState(viz); if (!st.touched && !bAdopt(viz)) bRender(viz); });
    return;
  }
  if (tries > 0) setTimeout(() => waitDraft(tries - 1), 150);
})(40);
})();
